import React from "react";
import Styles from "../styles/UsersList.module.css";

const UserContainer = ({ user, handleDelete, index }) => {
  return (
    <tr key={user.id}>
      <td>{index + 1}</td>
      <td>{user.username}</td>
      <td>{user.id}</td>
      <td>{user.email}</td>
      <td>
        <button
          className={Styles.delete_button}
          onClick={() => handleDelete(user.id)}
        >
          Delete
        </button>
      </td>
    </tr>
  );
};

export default UserContainer;
